import Grid from '@material-ui/core/Grid';
import { CardContent, Divider, Toolbar, Typography, TextField } from '@material-ui/core/';
import { Autocomplete } from '@material-ui/lab';
import Card from '@material-ui/core/Card';
import React, { useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import { useItems } from 'hooks/atoms/items-hook';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import BasicField from '../../basic/BasicField';
import { useStateObject } from '../../../hooks/utils';
import { useItem } from '../../../hooks/atoms/item-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import AppLoader from '../../basic/AppLoader';
import axiosClient from '../../../http/axios-client';
import ThematicPackageReportTemplateUpload from './thematic-package-report-preview/ThematicPackageReportTemplateUpload';
import AppButtonMain from '../../basic/AppButtonMain';
import { downloadThematicPackageTemplate } from '../../../http/download-assets-client';
import { CollectionItemHeader } from '../../layout';

const ThematicPackageReportPreview = (
  {
    id,
  },
) => {
  const {
    // eslint-disable-next-line no-unused-vars
    item: thematicPackage,
    itemIsLoading: thematicPackageLoading,
  } = useItem(CollectionKeys.THEMATIC_PACKAGES, id);

  const [ serial, setSerial ] = useState('');

  const [ kit, setKit ] = useState({});

  const [ downloadLoading, setDownloadLoading ] = useState(false);

  const newEndpoint = `${ CollectionKeys.REGISTRATION_KITS }?health_data_available=true&polygenic_risk_available=true&thematic_package.thematic_category_id.name=Cardio Health`;

  const [ localeStr, setLocaleStr ] = useState(2);
  const [ region, setRegion ] = useState('EU');

  const {
    items: registrationKits,
    itemsIsLoading: registrationKitsLoading,
  } = useItems(newEndpoint,
    {
      filterQuery: {
        _limit: -1,
      },
    });

  const {
    data: traitsWithReports,
    isLoading: traitsWithReportsLoading,
  } = useQuery(
    [ CollectionKeys.THEMATIC_PACKAGES_TRAITS, id, 'traits', localeStr, region ],
    () => {
      return axiosClient.get(`${ CollectionKeys.THEMATIC_PACKAGES_TRAITS }`, {
        params: {
          thematicpackage_id: id,
          _limit: -1,
        },
      }).then(async (dd) => {
        const promises = dd.map(async (d) => {
          const trait = d.trait_id;
          const context = await axiosClient.get(`contexts/unique?trait=${ trait.id }`);
          const template = await axiosClient.get(`templates?context=${ context.id }&_sort=published_at%3ADESC&locale=${ localeStr }&country_region=${ region }`);
          return {
            ...trait,
            traitContext: context,
            traitTemplate: template,
          };
        });
        return Promise.all(promises);
      });
    },
  );

  const loading = thematicPackageLoading || traitsWithReportsLoading || downloadLoading;

  const [ _user, setUserProperty ] = useStateObject({
    firstName: 'John',
    lastName: 'Doe',
    dateOfBirth: '1-1-1970',
    gender: 'male',
    age: '18',
  });

  // const userBasicDetails = [
  //   {
  //     field: 'firstName',
  //     label: 'First Name',
  //   },
  //   {
  //     field: 'lastName',
  //     label: 'Last Name',
  //   },
  //   {
  //     field: 'dateOfBirth',
  //     label: 'Date of birth',
  //   },
  //   {
  //     field: 'gender',
  //     label: 'Gender',
  //   },

  // ];

  const {
    mutateAsync: downloadTemplate,
    isLoading: templateIsDownloading,
  } = useMutation((p) => {
    return downloadThematicPackageTemplate(p);
  });

  if (loading) {
    return <AppLoader />;
  }

  return (
    <>
      <CollectionItemHeader
        title={ `Name: ${ thematicPackage.name }` }
        subtitle={ `Description: ${ thematicPackage.description }` }
      />
      <Toolbar />
      <Card>
        <Grid container spacing={ 3 }>
          <Grid item xs={ 12 }>
            <CardContent>
              <Typography variant='h5'>
                Template including cover, table of contents, general information, etc
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent>
              <ThematicPackageReportTemplateUpload id={ id } reason='pre' />
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <Divider style={ { margin: '0px 12px', height: '1px', backgroundColor: '#c8c8c8' } } />
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent style={ { display: 'flex', gap: '150px' } }>
              <Typography variant='h5'>
                Templates of traits
              </Typography>

              <div style={ { display: 'flex', gap: '50px' } }>
                <FormControl style={ { minWidth: 120 } }>
                  <InputLabel id='demo-simple-select-label'>Locale</InputLabel>
                  <Select
                    variant='standard'
                    labelId='demo-simple-select-label'
                    id='demo-simple-select'
                    value={ localeStr }
                    label='Locale'
                    onChange={ (e) => { setLocaleStr(Number(e.target.value)); } }
                  >
                    <MenuItem value={ 2 }>el-GR</MenuItem>
                    <MenuItem value={ 3 }>en-US</MenuItem>
                  </Select>
                </FormControl>

                <FormControl style={ { minWidth: 120 } }>
                  <InputLabel id='demo-simple-select-label-region'>Region</InputLabel>
                  <Select
                    variant='standard'
                    labelId='demo-simple-select-label-region'
                    id='demo-simple-select'
                    value={ region }
                    label='Region'
                    onChange={ (e) => { setRegion(e.target.value); } }
                  >
                    <MenuItem value='EU'>EU</MenuItem>
                    <MenuItem value='US'>US</MenuItem>
                  </Select>
                </FormControl>
              </div>

            </CardContent>
            <CardContent>
              {
                traitsWithReports.map((x) => {
                  return (
                    <Grid key={ x.id } container style={ { marginBottom: '12px' } }>
                      <Grid item xs={ 12 } style={ { marginBottom: '8px' } }>
                        <Typography
                          variant='h6'
                        >
                          {x.name.split(' ').map((c) => { return c.charAt(0).toUpperCase() + c.slice(1); }).join(' ')}
                        </Typography>
                      </Grid>
                      <Grid item xs={ 12 }>
                        <Grid
                          container
                          spacing={ 2 }
                          alignItems='center'
                        >
                          <Grid item xs={ 5 }>
                            <BasicField
                              disabled
                              title='Template url'
                              field={ x?.traitTemplate?.[0]?.location || 'Not uploaded yet' }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                  );
                })
              }
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <Divider style={ { margin: '0px 12px', height: '1px', backgroundColor: '#c8c8c8' } } />
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent>
              <Typography variant='h5'>
                Template including bibliography
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent>
              <ThematicPackageReportTemplateUpload id={ id } reason='post' />
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <Divider style={ { margin: '0px 12px', height: '1px', backgroundColor: '#c8c8c8' } } />
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent>
              <Typography variant='h5'>
                Demo user
              </Typography>
            </CardContent>
          </Grid>
          <Grid item xs={ 6 }>
            <Typography>
              Registration Kit
            </Typography>
            <CardContent>
              <Autocomplete
                size='small'
                options={ registrationKits?.map((regKit) => { return regKit; }) }
                getOptionLabel={ (option) => { return option?.serial_number_id?.serial || ''; } }
                value={ kit }
                disableClearable
                onChange={ (event, v) => {
                  console.log(v);
                  return [ setSerial(v.id),
                    setKit(v),
                    setUserProperty('firstName', v.customer_id.name),
                    setUserProperty('lastName', v.customer_id.family_name),
                    setUserProperty('dateOfBirth', v.customer_id.birthdate),
                    setUserProperty('gender', v.customer_id.gender),
                    setUserProperty('age', 25),
                  ];
                } }
                loading={ registrationKitsLoading }
                renderInput={ (params) => {
                  return (
                    <TextField
                      { ... params }
                      variant='outlined'
                      size='small'
                    />
                  );
                } }
              />
            </CardContent>
          </Grid>
          <Grid item xs={ 12 }>
            <Divider style={ { margin: '0px 12px', height: '1px', backgroundColor: '#c8c8c8' } } />
          </Grid>
          <Grid item xs={ 12 }>
            <CardContent>
              <AppButtonMain
                color='#0bae0e'
                text='Download'
                disabled={ templateIsDownloading || '' === serial }
                onClick={ () => {
                  setDownloadLoading(true);
                  return downloadTemplate(
                    {
                      thematicPackageId: id,
                      registrationKitId: serial,
                      demoMetadata: {
                        categoryPerTrait: {},
                        orderPerTrait: {},
                        localePerTrait: {
                          116: localeStr,
                          118: localeStr,
                          120: localeStr,
                          121: localeStr,
                          122: localeStr,
                          124: localeStr,
                        },
                      },
                      demoContent: {
                      },
                    },
                  )
                    .finally(() => {
                      setDownloadLoading(false);
                    });
                } }
              />
            </CardContent>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default ThematicPackageReportPreview;
